import { useProjectId } from "../../shopdrawing/ProjectName";
import { QuoteSwitcher } from "./QuoteSwitcher";
import { jsx as _jsx } from "react/jsx-runtime";
export function QuotePricingSwitcher() { const projectId = useProjectId(); return /*#__PURE__*/ _jsx(QuoteSwitcher, { title: "Project Pricing", url: `/project/${projectId}/shop-drawing/pricing`, quoteTitle: "Quote Pricing", quoteURL: `/project/${projectId}/quote/-1/pricing` }); }
